module.exports = __webpack_public_path__ + "img/nt118-06-81-1.prt.11deaa8c.jpg";